<!-- Header -->
<div class="control-header">
  <h2>Tablero de Control</h2>
  <div class="header-actions" *ngIf="esAdmin$ | async">
    <a class="reset-order-link" (click)="resetOrder()" title="Eliminar todos los reordenamientos manuales y volver al orden automático">
      Restablecer orden
    </a>
    <!-- <a class="reset-matches-link" (click)="resetAllMatches()" title="Pone los marcadores en cero, vacía los juegos y borra los events de arbitraje de TODOS los partidos del torneo">
      Reiniciar partidos
    </a> -->
    <div class="courts-config">
      <button class="court-btn" (click)="decreaseCourts()">-</button>
      <span class="courts-count">{{totalCourts}} canchas</span>
      <button class="court-btn" (click)="increaseCourts()">+</button>
    </div>
  </div>
</div>

<!-- Resumen rápido -->
<div class="summary-bar">
  <div class="summary-item">
    <span class="summary-number">{{matchesEnCancha.length}}</span>
    <span class="summary-label">En cancha</span>
  </div>
  <div class="summary-item">
    <span class="summary-number">{{freeCourts}}</span>
    <span class="summary-label">Libres</span>
  </div>
  <div class="summary-item">
    <span class="summary-number">{{matchesSiguientes.length + matchesEnEspera.length}}</span>
    <span class="summary-label">Pendientes</span>
  </div>
  <div class="summary-item">
    <span class="summary-number">{{matchesFinalizados.length}}</span>
    <span class="summary-label">Finalizados</span>
  </div>
</div>

<!-- Filtros de categoría -->
<div class="category-filters">
  <button class="filter-pill" [class.active]="!hasFilters" (click)="clearFilters()">
    Todas
  </button>
  <button
    *ngFor="let cat of categories"
    class="filter-pill"
    [class.active]="isCategorySelected(cat.category)"
    [style.--cat-color]="getCategoryColor(cat.category)"
    (click)="toggleCategory(cat.category)">
    {{cat.category}}
  </button>
</div>

<!-- Filtros de grupo (solo cuando hay una categoría seleccionada con más de un grupo) -->
<div class="group-filters" *ngIf="showGroupFilters">
  <span class="group-filters-label">Grupo:</span>
  <button class="group-pill" [class.active]="isGroupSelected(null)" (click)="selectGroup(null)">
    Todos
  </button>
  <button
    *ngFor="let g of availableGroups"
    class="group-pill"
    [class.finals]="g === 'finales'"
    [class.active]="isGroupSelected(g)"
    (click)="selectGroup(g)">
    {{groupLabel(g)}}
  </button>
</div>

<!-- Sección: En Cancha -->
<div class="section">
  <div class="section-header">
    <h3>En Cancha <span class="section-count">({{matchesEnCancha.length}})</span></h3>
  </div>
  <div class="section-content" *ngIf="matchesEnCancha.length > 0; else noEnCancha">
    <app-control-match-card
      *ngFor="let match of matchesEnCancha"
      [match]="match"
      [variant]="'en-cancha'"
      [isAdmin]="false"
      (showQr)="onShowQr($event)">
    </app-control-match-card>
  </div>
  <ng-template #noEnCancha>
    <div class="empty-section">No hay partidos en cancha</div>
  </ng-template>
</div>

<!-- Secciones arrastrables (Siguientes + En Espera) -->
<div cdkDropListGroup>

  <!-- Sección: Siguientes -->
  <div class="section">
    <div class="section-header">
      <h3>Siguientes <span class="section-count">({{matchesSiguientes.length}})</span></h3>
      <span class="drag-hint" *ngIf="esAdmin$ | async">Arrastra para reordenar</span>
    </div>
    <div
      class="section-content drag-list"
      cdkDropList
      [cdkDropListData]="matchesSiguientes"
      [cdkDropListDisabled]="!(esAdmin$ | async)"
      (cdkDropListDropped)="onDropSiguientes($event)">
      <app-control-match-card
        *ngFor="let match of matchesSiguientes; let i = index"
        cdkDrag
        [cdkDragData]="match"
        [cdkDragDisabled]="!(esAdmin$ | async)"
        [match]="match"
        [position]="match.globalPosition || (i + 1)"
        [variant]="'siguiente'"
        [isAdmin]="(esAdmin$ | async) ?? false"
        [isRecentlyMoved]="match.id === recentlyMovedId"
        (startMatch)="onStartMatch($event)"
        (setOrder)="onSetOrder($event)">
        <div class="drag-handle" cdkDragHandle *ngIf="esAdmin$ | async">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <circle cx="5" cy="3" r="1.5"/>
            <circle cx="11" cy="3" r="1.5"/>
            <circle cx="5" cy="8" r="1.5"/>
            <circle cx="11" cy="8" r="1.5"/>
            <circle cx="5" cy="13" r="1.5"/>
            <circle cx="11" cy="13" r="1.5"/>
          </svg>
        </div>
      </app-control-match-card>
    </div>
    <div class="empty-section" *ngIf="matchesSiguientes.length === 0">
      No hay partidos siguientes
    </div>
  </div>

  <!-- Sección: En Espera -->
  <div class="section" *ngIf="matchesEnEspera.length > 0">
    <div class="section-header">
      <h3>En Espera <span class="section-count">({{matchesEnEspera.length}})</span></h3>
      <span class="drag-hint" *ngIf="esAdmin$ | async">Arrastra para reordenar</span>
    </div>
    <div
      class="section-content drag-list"
      cdkDropList
      [cdkDropListData]="matchesEnEspera"
      [cdkDropListDisabled]="!(esAdmin$ | async)"
      (cdkDropListDropped)="onDropEspera($event)">
      <app-control-match-card
        *ngFor="let match of matchesEnEspera; let i = index"
        cdkDrag
        [cdkDragData]="match"
        [cdkDragDisabled]="!(esAdmin$ | async)"
        [match]="match"
        [position]="match.globalPosition || (matchesSiguientes.length + i + 1)"
        [variant]="'espera'"
        [isAdmin]="(esAdmin$ | async) ?? false"
        [isRecentlyMoved]="match.id === recentlyMovedId"
        (startMatch)="onStartMatch($event)"
        (setOrder)="onSetOrder($event)">
        <div class="drag-handle" cdkDragHandle *ngIf="esAdmin$ | async">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <circle cx="5" cy="3" r="1.5"/>
            <circle cx="11" cy="3" r="1.5"/>
            <circle cx="5" cy="8" r="1.5"/>
            <circle cx="11" cy="8" r="1.5"/>
            <circle cx="5" cy="13" r="1.5"/>
            <circle cx="11" cy="13" r="1.5"/>
          </svg>
        </div>
      </app-control-match-card>
    </div>
  </div>

</div>

<!-- Sección: Finalizados -->
<div class="section" *ngIf="matchesFinalizados.length > 0">
  <div class="section-header clickable" (click)="toggleFinalizados()">
    <h3>Finalizados <span class="section-count">({{matchesFinalizados.length}})</span></h3>
    <span class="toggle-icon">{{showFinalizados ? '▲' : '▼'}}</span>
  </div>
  <div class="section-content" *ngIf="showFinalizados">
    <app-control-match-card
      *ngFor="let match of matchesFinalizados"
      [match]="match"
      [variant]="'finalizado'"
      [isAdmin]="false">
    </app-control-match-card>
  </div>
</div>
